<template>
  <div>
    <b-overlay :show="isLoading" variant="white" rounded="sm">
      <!--begin::Header-->
      <!--begin::Form-->
      <b-form class="form" @submit.stop.prevent="onSubmit">
        <div
          role="alert" v-show="errors.length>0"
          v-bind:class="{ show: errors.length }"
          class="alert alert-danger"
        >
          <div class="alert-text" v-for="(error, i) in errors" :key="i">
            {{ error }}
          </div>
        </div>
        <div v-if="step2" class="d-flex align-items-stretch flex-column">
              <div class="alert alert-success messaging">
              <svg data-v-bc4e6392="" viewBox="0 0 16 16" width="1em" height="1em" focusable="false" role="img" aria-label="exclamation circle" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-exclamation-circle mx-auto b-icon bi"><g data-v-bc4e6392=""><path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"></path><path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"></path></g></svg>
              Su información ha sido cambiada de forma correcta.
            </div>
        </div>
         <div class="form-group row">
            <div class="col-lg-12">
              <h5 class="font-weight-bold mt-4 mb-4">Información Personal</h5>
            </div>
          </div>
         <div class="form-group">
            <label>Nombre</label>
           
                <b-form-input
                  class="form-control"
                  id="info-nombre"
                  name="nombre"
                  v-model="$v.form.nombres.$model"
                  :state="validateState('nombres')"
                  aria-describedby="info-nombre-mensaje-validacion"
                  placeholder="Nombre"
                  type="text"
                  maxLength="75"
                ></b-form-input>

                <b-form-invalid-feedback
                  id="info-nombre-mensaje-validacion"
                >El nombre es obligatorio.</b-form-invalid-feedback>
              
          </div>
          <div class="form-group">
            <label>Apellidos</label>
            <b-form-input
                  class="form-control"
                  id="info-apellidoPaterno"
                  name="apellidoPaterno"
                  v-model="$v.form.apellidos.$model"
                  :state="validateState('apellidos')"
                  aria-describedby="info-apellidoPaterno-mensaje-validacion"
                  placeholder="Apellidos"
                  type="text"
                  maxLength="75"
                ></b-form-input>

                <b-form-invalid-feedback
                  id="info-apellidoPaterno-mensaje-validacion"
                >El Apellido Paterno es obligatorio.</b-form-invalid-feedback>
              
          </div>

          <div class="row">
                    <div class="col-xl-6">
          <div class="form-group">
            <label>Celular</label>
                  <b-form-input
                    class="form-control"
                    id="info-celular"
                    name="telefono"
                    v-model="$v.form.telefono.$model"
                    :state="validateState('telefono')"
                    aria-describedby="info-celular-mensaje-validacion"
                    placeholder="Celular"
                    type="number"
                    maxLength="9"
                  ></b-form-input>

                  <b-form-invalid-feedback
                    id="info-celular-mensaje-validacion"
                  >Celular es obligatorio y no debe superar los 9 dígitos, Ej:991234567</b-form-invalid-feedback>
                
          </div>
                    </div>
                    <div class="col-xl-6">
          <div class="form-group">
            <label>Email</label>
            <b-form-input
                    class="form-control"
                    id="info-email"
                    name="email"
                    v-model="$v.form.email.$model"
                    :state="validateState('email')"
                    aria-describedby="info-email-mensaje-validacion"
                    placeholder="Email"
                    type="email"
                    maxLength="75"
                  ></b-form-input>

                  <b-form-invalid-feedback
                    id="info-email-mensaje-validacion"
                  >Email es obligatorio Ej: correo@gmail.com.</b-form-invalid-feedback>
               
          </div>
          </div></div>
        <button
            ref="kt_login_signin_submit"
            class="btn btn-primary align-self-center"
          >
            Actualizar
          </button>
        <!--end::Body-->
      </b-form>
      <!--end::Form-->
    </b-overlay>
  </div>

  <!-- </div> -->
  <!--end::Content-->
</template>

<style lang="scss">
@import "@/assets/sass/pages/login/login-1.scss";
</style>
<style>
.alert-custom-info-personal li {
  color: #f64e60 !important;
}
.alert-custom-info-personal-succsess {
  color: #1bc5bd !important;
}
.float-left {
  float: left;
}
</style>
<script>
import { mapState } from "vuex";
import { validationMixin } from "vuelidate";
import {
  email,
  required,
  minLength,
  maxLength
} from "vuelidate/lib/validators";
import { UPDATE_INFO } from "@/core/services/store/auth.module";

export default {
  name: "InformacionPersonal",
  mixins: [validationMixin],
  props: ["user", "isLoading"],
  data() {
    return {
      step2:false,
      form: {
        nombres: "",
        apellidos: "",
        telefono: "",
        email: ""
      }
    };
  },
  validations: {
    form: {
      nombres: {
        required,
        minLength: minLength(3)
      },
      apellidos: {
        required,
        minLength: minLength(3)
      },
      email: {
        required,
        email
      },
      telefono: {
        required,
        minLength: minLength(9),
        maxLength: maxLength(9)
      }
    }
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    // resetForm() {
    //   this.form = {
    //     nombre: null,
    //     apellidoPaterno: null,
    //     apellidoMaterno: null,
    //     celular: null,
    //     email: null,
    //     direccion: null
    //   };

    //   this.$nextTick(() => {
    //     this.$v.$reset();
    //   });
    // },
    
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      const submitButton = this.$refs["kt_login_signin_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      const nombres = this.$v.form.nombres.$model;
      const apellidos = this.$v.form.apellidos.$model;
      const telefono = parseInt(this.$v.form.telefono.$model);
      const email = this.$v.form.email.$model;

      // dummy delay
      setTimeout(() => {
        // send login request
        this.$store
          .dispatch(UPDATE_INFO, {
          email: email,
          nombres: nombres,
          apellidos: apellidos,
          telefono: telefono
          })
          // go to which page after successfully login
          .then(() => this.step2=true);

        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
      }, 500);
    }
  },
  beforeUpdate() {
      
  },
  mounted() {
    this.$nextTick(function() {
      this.$v.form.email.$model = this.user.email;
      this.$v.form.nombres.$model = this.user.nombres;
      this.$v.form.apellidos.$model = this.user.apellidos;
      this.$v.form.telefono.$model = this.user.telefono;
    });
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    })
  }
};
</script>